import React from 'react'
import styled from 'styled-components'
import fonts from '../../theme/fonts'
import Colors from '../../theme/colors'
import ErrorSvg from '../Icons/General/Error'
import { toBase64 } from '../../../util/image'

const ErrorIconBase64 = toBase64(<ErrorSvg color={Colors.Action.ErrorRed} />)

export const Input = styled.input`
  align-items: center;
  background: ${Colors.Primary.White};
  border-radius: 8px;
  border: 1px solid ${Colors.Primary.Grey};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  font-family: ${fonts.fontFamilies.Inter};
  font-size: ${fonts.fontSizes.p16};
  font-style: normal;
  font-weight: ${fonts.fontWeights.small};
  height: 48px;
  line-height: 16px;
  padding: 12px 16px;
  width: 100%;
  &:hover {
    border: 1px solid ${Colors.Primary.yellow500};
  }
  &:focus {
    outline: none;
    border: 1px solid ${Colors.Primary.yellow500};
  }
  &::placeholder {
    color: ${Colors.Primary.Grey};
  }
  &:disabled {
    color: ${Colors.Primary.GreyTextLight};
    background: ${Colors.Primary.GreyLight};
    border: 1px solid ${Colors.Primary.Grey};
  }
  &:not(:disabled).invalid {
    background: url("data:image/svg+xml;base64,${ErrorIconBase64}");
    background-position-x: calc(100% - 15px);
    background-position-y: 50%;
    background-repeat: no-repeat;
    background-size: 20px;
    border: 1px solid ${Colors.Action.ErrorRed};
  }
`

export const Label = styled.label`
  display: inline-block;
  margin-bottom: 8px;
`

export const Root = styled.section`
  width: 100%;
  h1 {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.01em;
    line-height: 16px;
  }
`
